import { Visibility } from "@mui/icons-material";
import { Box, Divider, IconButton, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

interface DocumentsProps {
  documents: FileSigner[];
  documentSelectedId: string;
  handleViewDocument: (doc: FileSigner) => void;
}

function Documents({
  documentSelectedId,
  documents,
  handleViewDocument,
}: DocumentsProps): React.JSX.Element {
  const { t } = useTranslation();
  return (
    <Stack spacing={3} sx={{ mt: 4 }}>
      <Box>
        <Typography
          sx={{ fontWeight: "500", fontSize: 16 }}
          variant="subtitle1"
        >
          {t("sign.documents.title")}
        </Typography>
        <Typography
          sx={{
            fontWeight: "400",
            fontSize: 14,
            color: "action.active",
          }}
          variant="body2"
        >
          {t("sign.documents.subtitle")}
        </Typography>
      </Box>
      <Stack spacing={1.25}>
        {documents.map((doc) => (
          <Box
            key={doc.id}
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              width: "100%",
              gap: "32px",
              backgroundColor:
                documentSelectedId === doc.id
                  ? "action.selected"
                  : "background.default",
            }}
          >
            <Box style={{ width: "100%" }}>
              <Box
                sx={{
                  padding: "8px",
                  height: "72px",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Typography
                  sx={{
                    fontWeight: "400",
                    fontSize: 16,
                    mr: 2,
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                  variant="body1"
                >
                  {doc.filename}
                </Typography>
                <IconButton
                  edge="end"
                  onClick={() => {
                    handleViewDocument(doc);
                  }}
                >
                  <Visibility />
                </IconButton>
              </Box>
              <Divider style={{ height: "1px" }} />
            </Box>
          </Box>
        ))}
      </Stack>
    </Stack>
  );
}

export default Documents;
